import { User, UserRole } from '../types';
import { getAuthItem, setAuthItem } from '../utils/authStorage';
import { decodeJwtRole } from '../utils/jwtPayload';
import authService from '../services/auth.service';

/** 以 JWT 中的 role 为准，修正多标签页切换账号后缓存 user 与 token 不一致 */
export function reconcileUserRoleWithToken(user: User | null): User | null {
  if (!user) return null;
  const jwtRole = decodeJwtRole(getAuthItem('access_token'));
  if (!jwtRole || jwtRole === user.role) return user;
  const reconciled = { ...user, role: jwtRole as UserRole };
  setAuthItem('user', JSON.stringify(reconciled));
  return reconciled;
}

export function resolveEffectiveUserRole(user: User | null | undefined): UserRole | string | undefined {
  const jwtRole = decodeJwtRole(getAuthItem('access_token'));
  return jwtRole || user?.role;
}

export async function initAuthState(): Promise<User | null> {
  if (!authService.isAuthenticated()) {
    return null;
  }
  let user = (await authService.fetchCurrentUser()) || authService.getCurrentUser();
  user = reconcileUserRoleWithToken(user);
  return user;
}
